import type { CustomCommunity4 } from '~/types'

export const useAggregateRatingSchema = ({
  community,
}: {
  community: Ref<CustomCommunity4 | undefined>
}) => {
  const route = useRoute()
  const runtimeConfig = useRuntimeConfig()
  const { baseUrl } = runtimeConfig.public

  return computed(() => {
    const rawCommunity = unref(community)

    if (rawCommunity?.slug === 'libre' || !rawCommunity?.stats) {
      return {}
    }

    let itemReviewed

    switch (rawCommunity?.slug) {
      case 'service': {
        itemReviewed = {
          '@type': 'SoftwareApplication',
          name: rawCommunity.title,
          applicationCategory: 'game',
          url: `${baseUrl}/communautes/${rawCommunity.slug}`,
          aggregateRating: {
            '@id': `${baseUrl}${route.path}/#aggregaterating`,
          },
        }
        break
      }
      case 'console': {
        itemReviewed = {
          '@type': 'Product',
          name: rawCommunity.title,
          brand: {
            '@type': 'Brand',
            name: 'Sony',
          },
          description: rawCommunity.description,
          image: rawCommunity.image_og?.url || rawCommunity.image_desktop?.url,
          url: `${baseUrl}/communautes/${rawCommunity.slug}`,
          aggregateRating: {
            '@id': `${baseUrl}${route.path}/#aggregaterating`,
          },
        }
        break
      }

      case 'jeu':
      default: {
        const platforms =
          rawCommunity.consoles?.map((item) => item.name) || undefined

        itemReviewed = {
          '@type': 'VideoGame',
          name: rawCommunity.title,
          applicationCategory: 'game',
          gamePlatform: platforms,
          operatingSystem: platforms,
          url: `${baseUrl}/communautes/${rawCommunity.slug}`,
          aggregateRating: {
            '@id': `${baseUrl}${route.path}/#aggregaterating`,
          },
        }
      }
    }

    return {
      type: 'application/ld+json',
      json: {
        '@context': 'https://schema.org',
        '@type': 'AggregateRating',
        '@id': `${baseUrl}${route.path}/#aggregaterating`,
        itemReviewed,
        reviewCount: rawCommunity.stats.total_review,
        ratingValue: rawCommunity.stats.rating,
        // fixed value
        worstRating: '1',
        bestRating: '5',
      },
    }
  })
}
